// settings/HamburgerMenu/sections/DictionarySection.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import Accordion from "~/components/utils/Accordion";
import DictionaryList from "../../DictionaryList";

const DictionarySection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Accordion
      items={[
        {
          title: `${t("dictionarySettings")}`,
          content: <DictionaryList />,
          dynamicHeight: true,
          autoHeight: true,
        },
      ]}
    />
  );
};

export default DictionarySection;
